// @ts-expect-error polyfill
var _Symbol;
(_Symbol = Symbol).dispose ?? (_Symbol.dispose = Symbol());
const disposablePromiseTimerResult = Symbol();
function timerResource(ms) {
    let timer = null;
    return {
        start () {
            if (timer) {
                throw new Error('Timer already started');
            }
            const promise = new Promise((resolve)=>{
                timer = setTimeout(()=>resolve(disposablePromiseTimerResult), ms);
            });
            return promise;
        },
        [Symbol.dispose]: ()=>{
            if (timer) {
                clearTimeout(timer);
            }
        }
    };
}

export { disposablePromiseTimerResult, timerResource };
